import { Attendant } from '../common/interfaces/attendant.interface'
import { apiRequest, ApiResponse } from '../request'

export interface AiCapability {
    key: string
    label: string
    description: string
    group: string
    tools: string[]
    essential?: boolean
    requiresPaymentAccount?: boolean
    available: boolean
}

export async function getAttendantCapabilities(): Promise<
    ApiResponse<AiCapability[]>
> {
    return apiRequest<AiCapability[]>('attendants/capabilities', {})
}

export async function getAttendants(filters?: { organizationId?: number }) {
    return await apiRequest<Attendant>('attendants', { params: filters })
}

export async function getAttendant(id: number) {
    return await apiRequest<Attendant>('attendants/' + id, {})
}

export async function getAttendantsByOrganization(
    organizationId: number,
    partnerId?: number | null
): Promise<ApiResponse<Attendant[]>> {
    const params = partnerId ? { partnerId } : {}
    return apiRequest<Attendant[]>(`attendants/organization/${organizationId}`, { params })
}

export async function createAttendant(data: {
    name: string
    rules: string
    metadata?: object
    enabledCapabilities?: string[]
    departmentId: number
    organizationId: number
    partnerId?: number
}): Promise<ApiResponse<Attendant>> {
    return apiRequest<Attendant>('attendants', { data }, 'post')
}

export async function updateAttendant(
    id: number,
    data: {
        name?: string
        rules?: string
        metadata?: object
        enabledCapabilities?: string[]
        departmentId?: number
    }
): Promise<ApiResponse<Attendant>> {
    return apiRequest<Attendant>('attendants/' + id, { data }, 'patch')
}

export async function deleteAttendant(id: number): Promise<ApiResponse<void>> {
    return apiRequest<void>(`attendants/${id}`, {}, 'delete')
}

export async function toggleOnHold(id: number): Promise<ApiResponse<Attendant>> {
    return apiRequest<Attendant>(`attendants/${id}/toggle-hold`, {}, 'patch')
}
